/**
 * @deprecated Please use axios.ts which will use Public API v3.
 * This one is ONLY for email inbox that is not yet changed with the conversations layer.
 * This one will be REMOVED when Public API v2 has been phased out.
 */

import axios, { AxiosInstance } from "axios";
import Vue from "vue";

// @NOTICE Authorization header will be set in @core/auth/jwt/jwtService via @/auth/jwt/useJwt. Should not be in @core...
const axiosInstance: AxiosInstance = axios.create({
    baseURL: process.env.VUE_APP_PUBLIC_API.replace("/v3", "/v2"),
    headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "OPTIONS,GET,POST,PATCH,PUT,DELETE",
        "Access-Control-Allow-Headers": "Content-Type",
        "x-api-key": "x-api-key-saysimple-frontend",
    },
});

Vue.prototype.$http = axiosInstance;

export default axiosInstance;
